<template>
  <div class="handleAdmin">
    <el-dialog
      title="添加管理员"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="140px"
        >
          <el-form-item label="管理员姓名" prop="nickName">
            <el-input
              v-model="formInline.nickName"
              style="width: 350px"
              placeholder="请输入管理员姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="管理员手机号" prop="mobile">
            <el-input
              v-model="formInline.mobile"
              style="width: 350px"
              placeholder="请输入管理员手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="formInline.password"
              style="width: 350px"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addAdminToCompany } from "@/api/organization";
export default {
  data() {
    return {
      dialogVisible: false,
      formInline: {
        nickName: "",
        mobile: "",
        password: "123456",
      },
      rules: {
        nickName: [
          { required: true, message: "请输入管理员姓名", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入管理员手机号", trigger: "blur" },
          { pattern: /^1[2-9]\d{9}$/, message: "请输入正确格式手机号", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      companyId: "",
    };
  },
  methods: {
    // 初始化
    init(companyId) {
      this.companyId = companyId || "";
      this.formInline = {
        nickName: "",
        mobile: "",
        password: "123456",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          addAdminToCompany({
            ...this.formInline,
            companyId: this.companyId,
          }).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.dialogVisible = false;
            }
          });
        }
      });
    },
  },
};
</script>